import { Controller } from "@hotwired/stimulus";

// Toggles the /professionals directory between two presentations of the same
// data — "list" (the Light-read cards) and "picture" (the image tiles) — like a
// light/dark switch. Both grids are rendered server-side; this just shows one.
// The choice is remembered in localStorage so it sticks across visits. The
// discipline rows (LOC-060) render one pair of grids per row, so every target
// on the page is switched, not just the first (Rob, 2026-10-01).
export default class extends Controller {
  static targets = ["list", "picture", "btn"];

  connect() {
    this.apply(localStorage.getItem("locals-pro-view") || "picture");
  }

  switch(event) {
    const view = event.currentTarget.dataset.view;
    localStorage.setItem("locals-pro-view", view);
    this.apply(view);
  }

  apply(view) {
    const picture = view === "picture";
    this.listTargets.forEach((el) => (el.hidden = picture));
    this.pictureTargets.forEach((el) => (el.hidden = !picture));
    this.btnTargets.forEach((b) => {
      const active = b.dataset.view === view;
      b.classList.toggle("is-active", active);
      b.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }
}
